export default __webpack_public_path__ + "static/media/avatarMenu.136fb9a7.svg";